<script>
/* eslint-disable */
import StartTab from "./StartTab.vue";
import EquipmentTab from "./EquipmentTab.vue";
import MusicTab from "./MusicTab.vue";
import ThatsIsTab from "./ThatsIsTab.vue";
import OutputsTab from "./OutputsTab.vue";
import ProductionTab from "./ProductionTab.vue";
import { mapGetters } from "vuex";
export default {
  name: "Tabs",
  components: {
    StartTab,
    EquipmentTab,
    MusicTab,
    ThatsIsTab,
    OutputsTab,
    ProductionTab,
  },
  data() {
    return {
      type: "",
      tabIndex: 0,
      id: this.$route.params.id ? this.$route.params.id : null,
    };
  },
  computed: {
    ...mapGetters({
      currentActivity: "warmups/currentActivity",
      musicTabErrors: "warmups/musicTabErrors",
      tabStatus: "warmups/tabStatus",
    }),
  },
  watch: {
    tabIndex(val) {},
  },
  mounted() {
    if (this.$route) {
      if (this.$route.path == "/create-warmup") {
        this.type = "warm-up";
      } else if (this.$route.path == "/create-workout") {
        this.type = "workout";
      }
    }
    this.$store.commit(`warmups/setTabStatus`, false);
  },
  methods: {
    tabActivated(newTabIndex, oldTabIndex, event) {
      this.$store.commit(`warmups/setActivityCurrentTab`, newTabIndex);
      if (this.tabStatus && newTabIndex !== 1) {
        if (confirm("Changes you made may not be saved.")) {
          this.$store.commit(`warmups/setTabStatus`, false);
        } else {
          event.preventDefault();
        }
      }
      if (newTabIndex == 1) {
        this.$store.commit("scripts/setOpened", true);
        event.preventDefault();
      }
    },
  },
};
</script>

<template>

  <b-card no-body>
    <b-tabs card v-model="tabIndex" v-on:activate-tab="tabActivated">
      <b-tab title="Start" active>
        <template #title>
          <span
            :class="id || currentActivity.working_title ? '' : 'text-danger'"
            class=""
            >Start</span
          >
          <b-icon
            v-if="
              !id ||
              !currentActivity.working_title ||
              !currentActivity.series ||
              !currentActivity.colour
            "
            icon="exclamation-triangle-fill"
            scale=".9"
            variant="danger"
          ></b-icon>
        </template>
        <start-tab></start-tab>
      </b-tab>
      <b-tab title="Script" :disabled="!id ? true : false">
        <template #title>
          <span :class="!id || !currentActivity.has_script && !currentActivity.filming_complete ? 'text-danger' : ''"
            >Script</span
          >
          <b-icon
            v-if="!id || !currentActivity.has_script && !currentActivity.filming_complete"
            icon="exclamation-triangle-fill"
            scale=".9"
            variant="danger"
          ></b-icon>
        </template>

        <b-card-text>Tab contents 2</b-card-text>
      </b-tab>
      <b-tab title="Equipment" :disabled="!id ? true : false">
        <template #title>
          <span
            :class="currentActivity.with_equipment != null ? '' : 'text-danger'"
            >Equipment</span
          >
          <b-icon
            v-if="!id || currentActivity.with_equipment == null"
            icon="exclamation-triangle-fill"
            scale=".9"
            variant="danger"
          ></b-icon>
        </template>

        <equipment-tab> </equipment-tab>
      </b-tab>
      <b-tab title="Music" :disabled="!id ? true : false">
        <template #title>
          <span
            :class="
              (currentActivity.spotify_playlist_name == null &&
                currentActivity.required_music) ||
              (currentActivity.apple_playlist_name == null &&
                currentActivity.required_music) ||
              (currentActivity.spotify_playlist_name == '' &&
                currentActivity.required_music) ||
              (currentActivity.apple_playlist_name == '' &&
                currentActivity.required_music)
                ? 'text-danger'
                : ''
            "
            >Music</span
          >
          <b-icon
            v-if="
              !id ||
              (!currentActivity.spotify_playlist_name &&
                currentActivity.required_music) ||
              (!currentActivity.apple_playlist_name &&
                currentActivity.required_music)
            "
            icon="exclamation-triangle-fill"
            scale=".9"
            variant="danger"
          ></b-icon>
        </template>
        <music-tab> </music-tab>
      </b-tab>
      <b-tab title="That's It" :disabled="!id ? true : false">
        <thats-is-tab></thats-is-tab>
      </b-tab>
      <b-tab title="Output" :disabled="!id ? true : false">
        <outputs-tab> </outputs-tab>
      </b-tab>
      <b-tab title="Production" :disabled="!id ? true : false">
        <production-tab> </production-tab>
      </b-tab>
    </b-tabs>
  </b-card>
</template>